import type { LatLng } from '~/_shared/types/latLng';
import { type ActiveMarker } from '~/_shared/types/marker.types';
import type { SpreadsheetRowId } from '~/_shared/types/spreadsheetData/spreadsheetRow';
import { type ActiveProximity } from '~/sidebar/sidebarApps/rightSidebar/rightSidebarConfiguration';
import {
  type BoundaryTerritoryIdentifier, type ExtendedBoundaryIdentifier,
} from '~/store/boundaries/boundaryIdentifier.type';

export type ActiveMapElementsState = Readonly<{
  activeMarker: ActiveMarker | null;
  activeMarkerNavigationIndex: number;
  activeBoundary: ExtendedBoundaryIdentifier | null;
  activeBoundaryTerritory: BoundaryTerritoryIdentifier | null;
  activeOverlappingElements: ActiveOverlappingMapElements;
  activeProximity: ActiveProximity | null;
  hoveredMarker: ActiveMarker | null;
  hoveredProximity: ActiveProximity | null;
  isLocationListActive: boolean;
}>;

export type ActiveOverlappingMapElements = Readonly<{
  activeOverlappingLocation: LatLng | null;
  boundaries: ReadonlyArray<OverlappingBoundaryTerritory>;
  proximities: ReadonlyArray<OverlappingProximity>;
  configuration: ActiveMapElementsConfiguration | null;
}>;

export enum ActiveMapElementsConfiguration {
  BoundaryTerritory = 'BoundaryTerritory',
  Proximity = 'Proximity',
}

export type OverlappingProximity = Readonly<{
  proximityId: string;
  spreadsheetRowId?: SpreadsheetRowId;
}>;

export type OverlappingBoundaryTerritory = Readonly<{
  boundaryTerritoryId: string;
}>;
